module.exports = __webpack_public_path__ + "static/media/ic_template_10.9b2bb7d1.png";